import React, {useEffect, useState} from "react";
import useAxiosPrivate from "../../../../hooks/useAxiosPrivate";
import {toastError, toastSuccess} from "../../../../helpers/Toast";
import "../../../../css/RecruitmentForm.css";

const value = v => v === null || v === undefined || v === "" ? "—" : String(v);
const yesNo = v => v ? "Tak" : "Nie";

export default function RecruitmentWaitingRoom() {
  const api = useAxiosPrivate();
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("NEW");
  const [selected, setSelected] = useState(null);

  const load = () => api.get("/recruitment-applications")
    .then(r => setItems(r.data || []))
    .catch(() => toastError("Nie udało się pobrać zgłoszeń"));

  useEffect(() => { load(); }, []);

  const accept = async item => {
    if (!window.confirm(`Utworzyć pracownika ${item.firstName} ${item.lastName} w etapie Poczekalnia?`)) return;
    try {
      await api.post(`/recruitment-applications/${item.id}/accept`);
      toastSuccess("Utworzono pracownika w etapie Poczekalnia");
      setSelected(null);
      load();
    } catch (e) {
      toastError(e.response?.data?.message || "Nie udało się zaakceptować zgłoszenia");
    }
  };

  const reject = async item => {
    const reason = window.prompt("Powód odrzucenia:");
    if (!reason?.trim()) return;
    try {
      await api.post(`/recruitment-applications/${item.id}/reject`, {reason: reason.trim()});
      toastSuccess("Zgłoszenie odrzucone");
      setSelected(null);
      load();
    } catch (e) {
      toastError(e.response?.data?.message || "Nie udało się odrzucić zgłoszenia");
    }
  };

  const visible = items.filter(x => filter === "ALL" || x.status === filter);

  return <div id="layoutSidenav_content">
    <div className="recruitment-waiting-room">
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h2 className="mb-0">Poczekalnia rekrutacyjna</h2>
      <select className="form-select form-select-sm" style={{width: 190}} value={filter} onChange={e => setFilter(e.target.value)}>
        <option value="NEW">Nowe</option>
        <option value="ACCEPTED">Zaakceptowane</option>
        <option value="REJECTED">Odrzucone</option>
        <option value="ALL">Wszystkie</option>
      </select>
    </div>
    <div className="table-responsive">
      <table className="table table-sm align-middle">
        <thead><tr><th>Data</th><th>Imię i nazwisko</th><th>PESEL</th><th>Telefon</th><th>E-mail</th><th>Status</th><th>Akcje</th></tr></thead>
        <tbody>{visible.map(x => <tr key={x.id}>
          <td>{x.createdAt?.replace("T", " ").slice(0, 16)}</td>
          <td>{x.firstName} {x.lastName}</td><td>{x.pesel}</td><td>{x.primaryPhone}</td><td>{x.privateEmail}</td><td>{x.status}</td>
          <td className="text-nowrap">
            <button className="btn btn-sm btn-outline-primary me-1" onClick={() => setSelected(x)}>Podgląd</button>
            {x.status === "NEW" && <>
              <button className="btn btn-sm btn-success me-1" onClick={() => accept(x)}>Utwórz pracownika</button>
              <button className="btn btn-sm btn-outline-danger" onClick={() => reject(x)}>Odrzuć</button>
            </>}
          </td>
        </tr>)}</tbody>
      </table>
    </div>
    {selected && <ApplicationDetails item={selected} onClose={() => setSelected(null)} onAccept={accept} onReject={reject}/>} 
    </div>
  </div>;
}

function ApplicationDetails({item, onClose, onAccept, onReject}) {
  const row = (label, val) => <div className="col-md-6 mb-2"><small className="text-muted d-block">{label}</small><div>{value(val)}</div></div>;
  const address = prefix => [item[`${prefix}AddressStreet`], item[`${prefix}AddressStreetNumber`], item[`${prefix}AddressPostalCode`], item[`${prefix}AddressCity`]].filter(Boolean).join(", ");
  return <div className="modal show d-block" tabIndex="-1" style={{background: "rgba(0,0,0,.35)"}}>
    <div className="modal-dialog modal-xl modal-dialog-scrollable"><div className="modal-content">
      <div className="modal-header"><h5 className="modal-title">Zgłoszenie: {item.firstName} {item.lastName}</h5><button type="button" className="btn-close" onClick={onClose}/></div>
      <div className="modal-body">
        <h6>Dane osobowe</h6><div className="row">{row("Imiona", [item.firstName,item.secondName].filter(Boolean).join(" "))}{row("Nazwisko",item.lastName)}{row("Nazwisko rodowe",item.maidenName)}{row("Data urodzenia",item.dateOfBirth)}{row("Miejsce urodzenia",item.placeOfBirth)}{row("Obywatelstwo",item.citizenship)}{row("Dowód osobisty",item.identityCardId)}{row("PESEL",item.pesel)}</div>
        <hr/><h6>Adres zameldowania</h6><div className="row">{row("Adres",address("primary"))}{row("Województwo ID",item.primaryAddressVoivodeshipId)}{row("Powiat",item.primaryAddressCounty)}{row("Gmina",item.primaryAddressCommune)}</div>
        <h6>Adres zamieszkania/korespondencyjny</h6><div className="row">{row("Adres",address("secondary"))}{row("Województwo ID",item.secondaryAddressVoivodeshipId)}{row("Powiat",item.secondaryAddressCounty)}{row("Gmina",item.secondaryAddressCommune)}</div>
        <hr/><h6>Kontakt i dane urzędowe</h6><div className="row">{row("Telefon",item.primaryPhone)}{row("E-mail",item.privateEmail)}{row("Kontakt awaryjny",[item.emergencyFirstName,item.emergencyLastName,item.emergencyPhone].filter(Boolean).join(" "))}{row("Oddział NFZ ID",item.nfzBranchId)}{row("Urząd Skarbowy ID",item.taxOfficeId)}</div>
        <hr/><h6>Dane do wypłat i status</h6><div className="row">{row("Numer konta",item.bankAccountNumber)}{row("Nazwa banku",item.bankName)}{row("Stopień niepełnosprawności",item.disabilityDegree)}{row("Emeryt",yesNo(item.retired))}{row("Rencista",yesNo(item.pensioner))}{row("Student",yesNo(item.student))}{row("Uczeń",yesNo(item.pupil))}{row("Zgłoszenie rodziny do ubezpieczenia",yesNo(item.familyHealthInsurance))}</div>
        <hr/><h6>Członkowie rodziny</h6>{item.familyMembers?.length ? item.familyMembers.map((x,i)=><div key={x.id || i}>{x.firstName} {x.lastName} · PESEL {value(x.pesel)} · {value(x.relationship)}</div>) : <div className="text-muted">Brak</div>}
        <h6 className="mt-3">Inne miejsca zatrudnienia</h6>{item.otherEmployments?.length ? item.otherEmployments.map((x,i)=><div key={x.id || i}>{x.employerName} · NIP {value(x.employerNip)}</div>) : <div className="text-muted">Brak</div>}
        {item.status === "REJECTED" && <><hr/><h6>Powód odrzucenia</h6><div>{value(item.rejectionReason)}</div></>}
      </div>
      <div className="modal-footer">{item.status === "NEW" && <><button className="btn btn-success" onClick={() => onAccept(item)}>Utwórz pracownika</button><button className="btn btn-outline-danger" onClick={() => onReject(item)}>Odrzuć</button></>}<button className="btn btn-secondary" onClick={onClose}>Zamknij</button></div>
    </div></div>
  </div>;
}
